/* Woodcraftees — size gate + catalog-ad deep-link handling (native Dawn, replaces Globo behaviours).
 *
 * WGT-parity UX (port of wheel-good-tees wgt-size-gate.js semantics to Dawn 15.3):
 *  - No size looks selected on landing (checked pill neutralised via .wc-gate-pending CSS; Dawn keeps its
 *    complete server variant under the hood). ATC reads "SELECT A SIZE"; pressing it shakes the pills +
 *    shows "Please select a size". Picking a size releases the gate.
 *
 * ADD-TO-CART ROBUSTNESS (the fix for the "first tap does nothing, second works" bug):
 *  Dawn disables the ATC button (native `disabled`) for ~0.5–1s while it fetches the section on every
 *  option change. A natively-disabled button swallows the tap, so a shopper who taps size then quickly taps
 *  ATC loses the first tap. We (a) keep the button tappable during that transient fetch (only when a size is
 *  chosen and in stock), and (b) if the form's variant hasn't caught up to the selection yet, DEFER the add
 *  until it has, then submit — so a mid-fetch tap adds the RIGHT variant instead of a stale one or nothing.
 *
 * CATALOG-AD DEEP-LINKS (?variant=<colour at random size>): upcharged size -> location.replace to the
 * colour's base variant so Shopify renders the base price (ad params preserved, no loop).
 *
 * Failure mode = today's behaviour: any error leaves Dawn stock (size preselected, no gate). */
(function () {
  'use strict';

  /* ---------- 1) deep-link: redirect upcharged size to the colour's base variant ---------- */
  try {
    if (location.pathname.indexOf('/products/') !== -1) {
      var params = new URLSearchParams(location.search);
      var vid = params.get('variant');
      if (vid && /^\d+$/.test(vid)) {
        var vs0 = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.variants;
        if (vs0) {
          var colorOf = function (v) { return (((v.public_title || v.name || '').split(' / ')[0]) || '').trim().toLowerCase(); };
          var uv = null, k;
          for (k = 0; k < vs0.length; k++) { if (String(vs0[k].id) === vid) { uv = vs0[k]; break; } }
          if (uv) {
            var base = null, c0 = colorOf(uv);
            for (k = 0; k < vs0.length; k++) { if (colorOf(vs0[k]) === c0) { base = vs0[k]; break; } }
            if (base && String(base.id) !== String(uv.id) && base.price < uv.price) {
              params.set('variant', String(base.id));
              location.replace(location.pathname + '?' + params.toString() + location.hash);
              return; // navigating away — skip the gate on this doomed document
            }
          }
        }
      }
    }
  } catch (e) { /* fall through to the gate */ }

  /* ---------- 2) size gate ---------- */
  var NEED = 'SELECT A SIZE';
  var MSG = 'Please select a size';
  var pending = true;                     // released on the first real size pick
  var attempted = false;                  // has the shopper hit ATC without a size yet?
  var deferring = false;                  // an add is queued behind an in-flight variant fetch

  // ----- element helpers -----
  function sizeFieldsets(root) {
    var out = [], fs = (root || document).querySelectorAll('fieldset.product-form__input--pill');
    for (var i = 0; i < fs.length; i++) {
      if (fs[i].closest('quick-add-modal')) continue;
      var lg = fs[i].querySelector('legend');
      if (lg && /size/i.test(lg.textContent || '')) out.push(fs[i]);
    }
    return out;
  }
  function mainProductForm() {
    return document.querySelector("product-info form[action*='/cart/add']:not([id*='installment'])")
        || document.querySelector("form[action*='/cart/add']:not([id*='installment'])");
  }
  function mainAtcButton() {
    var f = mainProductForm();
    return f ? f.querySelector('button[type="submit"], .product-form__submit') : null;
  }
  function mainFormVariantId() {
    var f = mainProductForm(); var el = f && f.querySelector('input[name="id"]');
    return el ? String(el.value || '') : '';
  }
  function checkedColorValue() {
    var i = document.querySelector('fieldset.product-form__input--swatch input[type="radio"]:checked');
    return i ? i.value : null;
  }
  function checkedSizeEl() {
    var fs = sizeFieldsets()[0];
    return fs ? fs.querySelector('input[type="radio"]:checked') : null;
  }
  // The variant id the shopper's currently-checked colour + size point at (from inline meta).
  function intendedVariantId() {
    var sEl = checkedSizeEl(); if (!sEl) return null;
    var s = (sEl.value || '').trim().toLowerCase();
    var c = checkedColorValue(); c = c ? c.trim().toLowerCase() : null;
    var vs = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.variants) || [];
    var target = c ? (c + ' / ' + s) : s;
    for (var i = 0; i < vs.length; i++) {
      if ((vs[i].public_title || '').trim().toLowerCase() === target) return String(vs[i].id);
    }
    return null;
  }
  function ensureMsg(btn) {
    var wrap = btn && btn.closest('.product-form__buttons');
    if (!wrap) return null;
    var m = wrap.parentNode.querySelector('.wc-select-msg');
    if (!m) {
      m = document.createElement('div');
      m.className = 'wc-select-msg'; m.textContent = MSG;
      wrap.parentNode.insertBefore(m, wrap);
    }
    return m;
  }

  // ----- pending visuals -----
  function apply() {
    if (!pending) return;
    sizeFieldsets().forEach(function (f) { f.classList.add('wc-gate-pending'); });
    var btn = mainAtcButton();
    if (btn) {
      var span = btn.querySelector('span');
      if (span && span.textContent.trim() !== NEED && !btn.querySelector('.sold-out-message:not(.hidden)')) {
        if (!span.dataset.wcOrig) span.dataset.wcOrig = span.textContent.trim();
        span.textContent = NEED;
      }
      ensureMsg(btn);
      if (attempted) { var m = ensureMsg(btn); if (m) m.classList.add('show'); }
    }
  }
  function release() {
    if (!pending) return;
    pending = false;
    sizeFieldsets().forEach(function (f) { f.classList.remove('wc-gate-pending'); });
    var btn = mainAtcButton();
    if (btn) {
      var span = btn.querySelector('span');
      var orig = (span && span.dataset.wcOrig) || (window.variantStrings && window.variantStrings.addToCart);
      if (span && span.textContent.trim() === NEED && orig) span.textContent = orig;
      var m = ensureMsg(btn); if (m) m.classList.remove('show');
    }
    keepAtcTappable();
  }
  function shake() {
    var fs = sizeFieldsets();
    fs.forEach(function (f) { f.classList.remove('wc-shake'); void f.offsetWidth; f.classList.add('wc-shake'); });
    if (fs[0]) fs[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // ----- keep the ATC button tappable during Dawn's transient variant fetch -----
  // Only once a size is chosen and that size is IN STOCK (sold-out sizes carry class "disabled").
  function keepAtcTappable() {
    if (pending) return;
    var sEl = checkedSizeEl();
    if (!sEl || sEl.classList.contains('disabled')) return;   // no size / sold out -> leave Dawn's state
    var b = mainAtcButton();
    if (b && b.hasAttribute('disabled')) b.removeAttribute('disabled');
  }

  // ----- release on a real size pick (change fires for a new size; click covers re-picking the default) -----
  document.addEventListener('change', function (e) {
    if (!e.isTrusted) return;
    var input = e.target;
    if (input && input.matches && input.matches("fieldset.product-form__input--pill input[type='radio']")) {
      var fs = input.closest('fieldset'), lg = fs && fs.querySelector('legend');
      if (lg && /size/i.test(lg.textContent || '')) { if (pending) release(); }
    }
  }, true);
  document.addEventListener('click', function (e) {
    if (!pending || !e.target.closest) return;
    var lbl = e.target.closest("fieldset.product-form__input--pill label");
    if (!lbl) return;
    var fs = lbl.closest('fieldset'), lg = fs && fs.querySelector('legend');
    if (lg && /size/i.test(lg.textContent || '')) release();
  }, true);

  // ----- gate / robustify the add-to-cart submit -----
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches("form[action*='/cart/add']")) return;
    if (form.closest('quick-add-modal')) return;
    if (!sizeFieldsets().length) return;

    if (pending) {                                            // no size chosen -> block + prompt
      e.preventDefault(); e.stopImmediatePropagation();
      attempted = true;
      var m = ensureMsg(mainAtcButton()); if (m) m.classList.add('show');
      shake();
      return;
    }

    // size chosen: if the form hasn't caught up to the selection (mid-fetch), defer the add until it does.
    var intended = intendedVariantId();
    if (intended && mainFormVariantId() !== intended) {
      e.preventDefault(); e.stopImmediatePropagation();
      deferAdd(intended);
    }
    // else: form already matches the selection -> let Dawn add normally.
  }, true);

  function deferAdd(intended) {
    if (deferring) return;
    deferring = true;
    var tries = 0;
    (function wait() {
      var b = mainAtcButton();
      if (mainFormVariantId() === intended && b && !b.hasAttribute('disabled')) {
        deferring = false;
        var f = mainProductForm();
        if (f) { f.requestSubmit ? f.requestSubmit() : f.submit(); }
        return;
      }
      if (++tries < 45) setTimeout(wait, 80);                 // ~3.6s ceiling
      else deferring = false;
    })();
  }

  // ----- boot + observers -----
  function boot() {
    if (!sizeFieldsets().length) { pending = false; return; }
    apply();
    // Dawn morphs product-info on every option change -> re-assert pending visuals & keep the button tappable.
    new MutationObserver(function () {
      requestAnimationFrame(function () { apply(); keepAtcTappable(); });
    }).observe(document.body, { childList: true, subtree: true });
    // React the instant Dawn toggles a `disabled` attribute (its transient button disable).
    new MutationObserver(function () { keepAtcTappable(); })
      .observe(document.body, { attributes: true, subtree: true, attributeFilter: ['disabled'] });
  }
  document.readyState !== 'loading' ? boot() : document.addEventListener('DOMContentLoaded', boot);
})();
